export default __webpack_public_path__ + "assets/webgl/complete-21.926c9c4c.jpg";